import type * as SeparatorPrimitive from "@radix-ui/react-separator";
import type { ComponentPropsWithoutRef, ComponentRef } from "react";

import { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const SEPARATOR_ORIENTATION_CLASS_MAP = {
  horizontal: "w-full border-t",
  vertical: "h-full border-l",
} as const;

/*-------------------------------------
|  Types
-------------------------------------*/

export type TSeparatorElement = ComponentRef<typeof SeparatorPrimitive.Root>;

export type TSeparatorProps = ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>;

type TSeparatorDefaultProps = DefinedDefaults<TSeparatorProps, "orientation" | "decorative">;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const SEPARATOR_DEFAULTS = {
  orientation: "horizontal",
  decorative: true,
} satisfies TSeparatorDefaultProps;
